var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, cloneElement } from 'react';
import cx from 'classnames';
import styles from './Link.module.css';
export var LinkSize;
(function (LinkSize) {
    LinkSize["Size100"] = "100";
    LinkSize["Size200"] = "200";
    LinkSize["Size300"] = "300";
    LinkSize["Size400"] = "400";
})(LinkSize || (LinkSize = {}));
export var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition || (IconPosition = {}));
export var Target;
(function (Target) {
    Target["Self"] = "_self";
    Target["Blank"] = "_blank";
})(Target || (Target = {}));
export const Link = forwardRef((_a, ref) => {
    var { children, className, disabled, href, label, icon, masked, target = Target.Self, iconPosition = IconPosition.Left, size = LinkSize.Size100 } = _a, other = __rest(_a, ["children", "className", "disabled", "href", "label", "icon", "masked", "target", "iconPosition", "size"]);
    const extraProps = {};
    let TagName = 'button';
    if (disabled) {
        TagName = 'span';
    }
    else if (href) {
        TagName = 'a';
        extraProps.target = target;
        extraProps.href = href;
        if (target === Target.Blank) {
            extraProps.rel = 'noopener noreferrer';
        }
        if (masked && href !== undefined) {
            if (extraProps.rel) {
                extraProps.rel = `${extraProps.rel} nofollow`;
            }
            else {
                extraProps.rel = 'nofollow';
            }
        }
    }
    return (React.createElement(TagName, Object.assign({ className: cx({ [styles.disabled]: disabled }, styles[`size-${size}`], styles.component, className), ref: ref }, extraProps, other),
        iconPosition === IconPosition.Left &&
            icon &&
            cloneElement(icon, {
                className: cx(icon.props.className, styles.icon, {
                    [styles.iconLeft]: !!label || !!children
                })
            }),
        label,
        children,
        iconPosition === IconPosition.Right &&
            icon &&
            cloneElement(icon, {
                className: cx(icon.props.className, styles.icon, {
                    [styles.iconRight]: !!label || !!children
                })
            })));
});
//# sourceMappingURL=Link.js.map